import {ReactNode} from 'react';
import Box from '@mui/material/Box';
import {SxProps, Theme} from '@mui/material/styles';
import {kit, radius} from './tokens';

interface StatTileProps {
  value: ReactNode;
  label: string;
  sx?: SxProps<Theme>;
}

// A single dashboard stat tile -- web port of `.stat` in
// web-detail-1-quotes.html (see `.stats` grid in web-contractor-4-dashboard).
export const StatTile = ({value, label, sx}: StatTileProps) => (
  <Box
    sx={[
      {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${kit.line}`,
        borderRadius: `${radius.lg}px`,
        boxShadow: '0 4px 14px rgba(19,33,46,.05)',
        padding: '16px 18px 15px',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    <Box
      sx={{
        fontSize: 23,
        fontWeight: 700,
        letterSpacing: '-0.4px',
        color: kit.ink,
      }}>
      {value}
    </Box>
    <Box
      sx={{fontSize: 12, fontWeight: 600, color: kit.slate, marginTop: '4px'}}>
      {label}
    </Box>
  </Box>
);

interface StatTileRowProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

// Wraps a row of StatTiles: four across at >=1024 (theme `md`), wrapping to
// a 2x2 grid below it -- per the approved rulebook, the tile values never
// shrink, only the grid reflows.
export const StatTileRow = ({children, sx}: StatTileRowProps) => (
  <Box
    sx={[
      (theme) => ({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '14px',
        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: 'repeat(4, 1fr)',
        },
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    {children}
  </Box>
);
